<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <title-edit header="Contact" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Mini TCDC name :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="optionMiniTCDC" :model="form.tcdc_mini_id" @update="updateMiniTCDCName" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Title TH :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.title_th" @update="updateTitleTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Title EN :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.title_en" @update="updateTitleEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Contact email :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.contact_email" @update="updateContactEmail" />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteContact" @save-info="saveContact" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import SelectOption from "../../../components/Input/selectOption";
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import { mapState } from "vuex";
import Swal from 'sweetalert';
import {
  permissionContact,
  role
} from "../../../util/Permission";
import CommandButton from "../../../components/Layout/CommandButton";
import Loading from 'vue-loading-overlay';

export default {
  name: "ContactEdit",
  components: {
    CommandButton,
    SaveButton,
    PreviewButton,
    DeleteButton, InputEditor, InputTextField,
    SelectOption, LineHr, TitleEdit,
    Loading
  },
  computed: {
    permissionContact,
    ...mapState({
      form: state => {
        return state.Contact.form;
      }
    })
  },
  data() {
    return {
      permission: null,
      optionBranch: [],
      optionMiniTCDC: [],
      save_id: null,
      isLoading: false
    }
  },
  created() {
    this.permission = role;
    this.getBranchData();
    this.getMiniTCDC();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    getMiniTCDC() {
      if (this.form.branch_id) {
        this.$store.dispatch("TCDCMini/getTCDCMiniByBranch", this.form.branch_id).then(res => {
          this.optionMiniTCDC = [
            { text: "Select", value: "" },
            ...res.map(data => ({
              value: data.id,
              text: data.branch_name_en,
            }))
          ];
        })
      }
    },
    validateData() {
      if (!this.form.branch_id) {
        Swal('', 'Please Select Branch', 'error');
        return false;
      } else if (!this.form.description_th) {
        Swal('', 'Please input Description TH', 'error');
        return false;
      } else if (!this.form.description_en) {
        Swal('', 'Please input Description EN', 'error');
        return false;
      }
      else {
        return true;
      }
    },
    saveClose() {
      if (this.validateData()) {
        this.$store.dispatch("Contact/saveContact", {
          id: this.save_id ? this.save_id : this.form.id,
          data: this.form
        }).then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToContact();
          }
        }).catch(() => {
          Swal('', 'Cannot save contact data', 'error');
        })
      }
    },
    saveContact() {
      this.isLoading = true;
      if (this.validateData()) {
        this.$store.dispatch("Contact/saveContact", {
          id: this.save_id ? this.save_id : this.form.id,
          data: this.form
        }).then(res => {
          this.save_id = res.result.id;
          this.isLoading = false;
          Swal(res.response_msg);
        }).catch(() => {
          this.isLoading = false;
          Swal('', 'Cannot save contact data', 'error');
        })
      }
    },
    deleteContact() {
      this.$store.dispatch("Contact/deleteContact", this.form.id).then(res => {
        Swal(res.response_msg);
        if (res.response_code == 200) {
          this.goToContact();
        }
      }).catch(() => {
        Swal('', 'Cannot delete contact data', 'error');
      })
    },
    goToContact() {
      this.$router.push("/about/contact");
    },
    updateBranch(val) {
      this.form.branch_id = val;
      this.getMiniTCDC();
    },
    updateMiniTCDCName(val) {
      this.form.tcdc_mini_id = val;
    },
    updateTitleTH(val) {
      this.form.title_th = val;
    },
    updateTitleEN(val) {
      this.form.title_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateContactEmail(val) {
      this.form.contact_email = val;
    }
  }
}
</script>

<style scoped></style>
